<template>
    <div class="confirmation">
        <div class="confirmation__overlay" @click="isOpenConfirm(false)"/>
        <div class="confirmation__inner relative" data-testid="contract-register-container">
            <div class="absolute right-1 top-2 z-[999]">
                <i class="confirmation__close" @click="emit('onclose')">
                    <svg class="icon icon_color_white">
                        <use xlink:href="/img/sprites/icons-sprite.svg#icon-close"></use>
                    </svg>
                </i>
            </div>
            <component :is="stepForm" />
        </div>
    </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, defineProps, defineEmits, onMounted, onUnmounted } from 'vue'
import Register from './components/Register.vue'
import Forms from './components/forms'

const store = useStore();
const emit = defineEmits(['onclose'])

const props = defineProps({
    coursetype: String
})

const paidCourseType = computed(() => store.getters.paidcourse?.coursetype || 'training')
const userContract = computed(() => store.getters.usercontract)
const stepForm = computed(() => {
    if (!userContract.value) {
        return Register // ** step 1. basic user contract registration (relevant for course type `training`)
    } else if (!userContract.value.diplom_scan) {
        return Forms[`coursetype-${paidCourseType.value}`] ?? Forms[`coursetype-professional`] // ** step 2. extra registration form (relevant for course type, or use `professional` from by default)
    }
    return 0 // ** contract is registerd, no more registration data needed
})

const isOpenConfirm = (value) => {
    store.commit('setIsActiveConfirm', value)
}

onMounted(() => {
    document.body.style.overflow = 'hidden'
})
onUnmounted(() => {
    document.body.style.overflow = 'auto'
})
</script>

<style lang="scss" scoped>
@import './scss/confirmation.scss';
</style>
